'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var Fg = function (_React$Component) {
    _inherits(Fg, _React$Component);

    function Fg() {
        _classCallCheck(this, Fg);

        return _possibleConstructorReturn(this, (Fg.__proto__ || Object.getPrototypeOf(Fg)).apply(this, arguments));
    }

    _createClass(Fg, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M19.924 10.122c-2.094 0-4.499-0.21-7.158-0.629-8.303-1.311-12.128-0.032-12.165-0.018-0.216 0.076-0.451-0.039-0.525-0.255s0.039-0.451 0.255-0.526c0.161-0.056 4.057-1.361 12.566-0.018 5.148 0.813 9.3 0.829 12.007 0.046 0.059-0.017 0.104-0.030 0.136-0.038 0.22-0.056 0.445 0.080 0.501 0.301s-0.079 0.445-0.3 0.501l-0.107 0.030c-1.398 0.404-3.152 0.607-5.207 0.607z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M19.924 14.97c-2.094 0-4.499-0.21-7.158-0.629-8.303-1.311-12.128-0.031-12.165-0.018-0.214 0.076-0.45-0.039-0.525-0.254s0.039-0.451 0.255-0.526c0.161-0.057 4.057-1.361 12.566-0.018 5.148 0.813 9.3 0.828 12.007 0.045 0.059-0.017 0.104-0.030 0.136-0.038 0.22-0.057 0.445 0.080 0.501 0.301s-0.079 0.445-0.3 0.501l-0.107 0.030c-1.398 0.404-3.152 0.606-5.207 0.606z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M19.924 19.818c-2.094 0-4.499-0.21-7.158-0.63-8.303-1.311-12.128-0.031-12.165-0.018-0.214 0.076-0.45-0.039-0.525-0.254s0.039-0.451 0.255-0.526c0.161-0.055 4.057-1.361 12.566-0.018 5.148 0.812 9.3 0.828 12.007 0.045 0.059-0.017 0.104-0.030 0.136-0.038 0.22-0.055 0.445 0.079 0.501 0.3s-0.079 0.446-0.3 0.501l-0.107 0.030c-1.398 0.404-3.152 0.607-5.207 0.607z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M19.924 24.666c-2.094 0-4.5-0.21-7.159-0.63-8.271-1.307-12.128-0.030-12.166-0.018-0.215 0.074-0.45-0.041-0.525-0.255s0.039-0.45 0.255-0.524c0.162-0.056 4.057-1.361 12.566-0.018 5.151 0.814 9.301 0.83 12.007 0.045 0.059-0.017 0.104-0.030 0.136-0.038 0.221-0.053 0.446 0.079 0.501 0.301 0.055 0.22-0.079 0.445-0.3 0.501l-0.107 0.029c-1.398 0.405-3.152 0.608-5.207 0.608z' })
            );
        }
    }]);

    return Fg;
}(_react2.default.Component);

Fg.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = Fg;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/weather/fg.js
// module id = 1136
// module chunks = 0